"use client";

import { useMutation } from "@tanstack/react-query";

import { useToast } from "@/components/ui/use-toast";

import { postRegistryRead } from "@/services/registry";

interface Props {
  url: string;
}

export const usePostRegistryRead = () => {
  const { toast } = useToast();

  const mutation = useMutation({
    mutationFn: async ({ url }: Props) => await postRegistryRead(url),
    onError: (error) => {
      toast({
        title: "Erro ao ler matrícula",
        description:
          error instanceof Error
            ? error.message
            : "Ocorreu um erro ao ler a matrícula",
        variant: "destructive",
      });
    },
  });

  return mutation;
};
